<template>
  <el-row :gutter="8">
    <el-col v-if="rowData.organisation || rowData.person" :span="this.isManager() ? 14 : 23">
      <contacts-popover :row-data="rowData" />
    </el-col>

    <el-col v-if="this.isSuper()" :span="rowData.organisation || rowData.person ? 8 : 23">
    <el-button v-if="isSuper() && !(rowData.category.indexOf('Xolas-Client') > 0)" icon="fa fa-trash"
    @click="deleteEntry()" size="small" type="danger" circle :disabled="isViewOnly() || rowData.active > 0"></el-button>
    </el-col>
  </el-row>
  </template>

  <script>

  import PostMixins from '@/mixins/PostMixins'
  import ContactsPopover from '@/components/atoms/ContactsPopover'

  export default {
    mixins: [PostMixins],

    components: {
      ContactsPopover
    },

    props: {

      rowData: {
        type: Object,
        required: true
      },

      tableRef: {
        type: String,
        default: 'orgtable'
      }

    },


    methods: {

      deleteEntry () {
        this.deleteItem(this, this.rowData.id, '/org', this.rowData.name + ' AND all records in the system associated with this organisation. Are you absolutely sure?', this.onDelete)
      },

      onDelete (response) {
        this.$events.fire(this.tableRef + '-refresh-table')
        this.updateConfig()
        this.$emit('update-stats')

      }
    }
  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>



// WEBPACK FOOTER //
// OrgControls.vue?7c24343e